<template>
  <div class="tasto" :style="btnPosition" :class="{'selected': isSelected }" v-show="visible">
    <div v-if="infoTasti" class="debugText">{{ts.action.type || ts.variableToDisplay}}</div>
    <div v-if="isPage" class="flag-page"></div>
    <img v-if="image" :src="calcImage" class="button-image" :style="imgStyle" @click="onClick"/>
    <van-icon v-if="locked" class="role-lock" :name="locked === 1 ? 'bag-o' : 'bag'" color="blue" :title="locked === 1 ? 'Disabilitato per RuoloTasto' : 'Disabilitato per ruoliDisab o utentiDisab su database'"/>
    <button
      style="width:100%; height: 100%;"
      @click="onClick"
      ref="btnTasto"
      :class="[ aspectTestCondition ? '' : aspect, { disabled: disabled }, validDisplay ? aspectIfValid : '', aspectTestCondition ? aspectIfCondition : '']"
    >
      {{displayedText}}
    </button>
    <div v-if="attribute" class="attribute">{{attribute}}</div>
    <div v-if="title2th" class="smallText">{{title2th}}</div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    row: { type: Number, required: true }, // Inserire eventuali validatori
    col: { type: Number, required: true }, // es validator: function(value) { return value > 0 && value <= 6 }
    row_span: { type: Number, required: true },
    col_span: { type: Number, required: true },
    aspect: { type: String, default: '' },
    aspectIfValid: { type: String, default: '' },
    aspectIfCondition: { type: String, default: '' },
    aspectTestCondition: Boolean,
    title: String,
    title2th: { type: String, default: '' },
    action: Object,
    status: Object,
    attribute: String,
    hiddenTestCondition: String,
    forzaTastoHidden: Boolean,
    infoTasti: Boolean,
    disabled: Boolean,
    locked: Number,
    variableToDisplay: { default: '' },
    valueToDisplay: { default: '' },
    maxChar: { type: Number, default: 0 },
    ts: Object,
    zona: String,
    /*     index: Number,
    indexSelected: Number, */
    /* codiceTasto: String, */
    itemSelected: String,
    helpEnabled: { type: Boolean, default: false },
    image: { type: String, default: '' }
  },
  data() {
    return {
      datenow: '',
      timenow: '',
      interval: null,
      isSelected: false,
      btnWidth: 0,
      btnHeight: 0,
      posImage: 5 // da 1 a 9 : 1=(sx, alto), 2=(centro, alto), 3=(dx, alto), 4=(sx, centro), ...,
    }
  },
  mounted() {
    if (this.valueToDisplay && ['datenow', 'timenow'].includes(this.valueToDisplay)) {
      this.interval = setInterval(this.time, 1000)
    }
    // if (this.image) {
    const tasto = this.$refs.btnTasto
    this.btnWidth = tasto.offsetWidth
    this.btnHeight = tasto.offsetHeight
    // }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval)
  },
  computed: {
    btnPosition() {
      return `grid-area: ${this.row} / ${this.col} / span ${this.row_span} / span ${this.col_span};`
    },
    attributeValue() {
      return '0000'
    },
    displayedText() {
      switch (this.valueToDisplay) {
        case '':
          if (!this.maxChar) return this.title
          return this.maxChar > 0 ? this.title.slice(0, this.maxChar) : this.title.slice(this.maxChar)
        case 'datenow':
          return this.datenow
        case 'timenow':
          return this.timenow
        default:
          if (!this.maxChar) return this.valueToDisplay
          return this.maxChar > 0 ? this.valueToDisplay.slice(0, this.maxChar) : this.valueToDisplay.slice(this.maxChar)
      }
    },
    validDisplay() {
      return this.displayedText !== ''
    },
    // isSelected() {
    //   return this.ts.codiceTasto === this.itemSelected
    // },
    visible() {
      // return !this.hiddenTestCondition
      if (this.hiddenTestCondition && this.forzaTastoHidden) {
        return false
      }
      return true
    },
    isPage() {
      return this.ts && this.ts.action && this.ts.action.type && ['PRODOTTI_PAGINA', 'REPARTI_PAGINA'].includes(this.ts.action.type)
    },
    imgStyle() {
      const { imgWidth, imgHeight, mTop, mLeft } = this.calcTopLeft()

      return `width: ${imgWidth}px; height: ${imgHeight}px; margin-top: ${mTop}px; margin-left: ${mLeft}px;`
    },
    calcImage() {
      return `/img/tasti/${this.image}`
    }
  },
  methods: {
    time() {
      this.datenow = moment().format('L')
      this.timenow = moment().format('HH:mm')
    },
    onClick(e) {
      // e.currentTarget.parentElement.style.gridColumnStart = '4'
      // e.currentTarget.parentElement.style.gridColumnEnd = 'span 3'
      // e.currentTarget.parentElement.style.gridRowStart = '9'
      // e.currentTarget.parentElement.style.gridRowEnd = 'span 3'

      e.stopPropagation()
      // if (this.zona === 'tasti' && ['PRODOTTO', 'REPARTO', 'REPARTO_SCONTO', 'PRODOTTI_PAGINA'].includes(this.ts.action.type)) {
      // if (this.zona === 'tasti') {
      //   this.$emit('selected', this.ts, !this.isSelected)
      // }
      if (this.zona === 'tasti' || this.zona === 'tasti1' || this.zona === 'tasti2') {
        // this.$emit('selected', this.ts, !this.isSelected)
        this.$emit('select-tasto', this.ts, this)
      }
    },
    select() {
      this.isSelected = true
    },
    deselect() {
      this.isSelected = false
    },
    sendToMachine(actionType) {
      const event = {
        type: actionType,
        value: this.action.payload
      }
      this.$emit('send-event', event)
    },
    calcTopLeft() {
      let mTop = 0
      let mLeft = 0
      let imgWidth = this.btnWidth / 2
      let imgHeight = this.btnHeight / 2
      let deltaW = this.btnWidth - imgWidth
      let deltaH = this.btnHeight - imgHeight
      switch (this.posImage) {
        case 1:
          mTop = 0
          mLeft = 0
          break
        case 2:
          mTop = 0
          mLeft = deltaW / 2
          break
        case 3:
          mTop = 0
          mLeft = deltaW
          break
        case 4:
          mTop = deltaH / 2
          mLeft = 0
          break
        case 5:
          mTop = deltaH / 3
          mLeft = deltaW / 3
          imgWidth = this.btnWidth * 2 / 3
          imgHeight = this.btnHeight * 2 / 3
          break
        case 6:
          mTop = deltaH / 2
          mLeft = deltaW
          break
        case 7:
          mTop = deltaH
          mLeft = 0
          break
        case 8:
          mTop = deltaH
          mLeft = deltaW / 2
          break
        case 9:
          mTop = deltaH
          mLeft = deltaW
          break
        default:
          break
      }
      deltaW = this.btnWidth - imgWidth
      deltaH = this.btnHeight - imgHeight
      return { imgWidth, imgHeight, mTop, mLeft }
    }
  }
}
</script>

<style scoped lang="scss">
  .tasto {
    /* margin: 0 0 6px 6px; */
    &.selected {
      border-color: red;
      border-width: 1px;
      border-style: solid;
    }
  }

  button {
    padding: 0 10px;
  }

  button.default-hidden:not(.visible) {
    display: none;
  }

  .smallText {
    top: -1.6em;
    right: 0.8em;
    position: relative;
    float: right;
    font-weight: 400;
    font-family: Arial;
    color: #666666;
    /*  MANUEL: tolto font-family: 'Montserrat'; per uniformarlo...smallText sta anche sui css delle modali, è corretto metterlo su più parti ?! */
  }

  .debugText {
    align-self: start;
    position: absolute;
    margin-top: 4px;
    margin-left: 4px;
    font-family: 'Montserrat';
    font-weight: 400;
    font-size: 10px;
    color: red;
  }

  .attribute {
    top: -23px;
    text-align: center;
    position: relative;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    margin: 0 0 6px 6px;
    color: red
  }

  .disabled {
    background-color:#00000050 ;
    color:#00000050 ;
  }

  .align-left {
    text-align: left;
  }

  .align-right {
    text-align: right;
  }

  @media all and (min-width:768px) {
    button {padding: 0 5px;}
  }

  .flag-page{
    align-self: start;
    position: absolute;

    /* Freccia */
  /* width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #f00;*/

    /* Bandiera */
    background-color: red;
    height: 10px;
    margin-top: 1 px;
    margin-left: 1 px;
    width: 10px;
    border-radius: 3px 0 0 0;
  }

  .role-lock {
    position: absolute;
    align-self: end;
    cursor: default;
  }

  .button-image {
    position: absolute;
  }

  .button-image2 { /* non usato per adesso */
    /* background-color: #cccccc;  *//* Used if the image is unavailable */
    /* height: 500px; */ /* You must set a specified height */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
  }
</style>
